import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const DataContextReact = createContext(null);
/**
 * Shared React context provider for a `DataContext` (`shell` + `hub`).
 *
 * Both shells (Desktop, Web) construct their `DataContext` locally — each
 * builds its own shell adapter set and its own HubClient impl — and then
 * wraps the app tree in this provider. That keeps all shell-specific
 * construction at the app-entry level and all UI components shell-agnostic.
 */
export function DataContextProvider({ ctx, children, }) {
    return _jsx(DataContextReact.Provider, { value: ctx, children: children });
}
export function useDataContext() {
    const ctx = useContext(DataContextReact);
    if (!ctx) {
        throw new Error("useDataContext must be called inside <DataContextProvider>.");
    }
    return ctx;
}
//# sourceMappingURL=data-context-provider.js.map